import Joi from 'joi-browser';
import { NUMBER_OF_FIELD_ITEM_TYPE } from '../constants';
import dayworkerFormSchema from './dayWorker';

export const workMultipleEditSchema = Joi.object().keys({
  // work_hour_zone: Joi.number().required(),
  work_date: Joi.string().required(),
  field_tree_id: Joi.number().required(),
  job_id: Joi.number().required(),
  foreman_user_id: Joi.number().required(),
  main_work_type_id: Joi.number().when('isMainTypeRequired', {
    is: true,
    then: Joi.required(),
  }),
  sub_work_type_id: Joi.number().when('isSubTypeRequired', {
    is: true,
    then: Joi.required(),
  }),
  a_item_id: Joi.allow(null).when('required_item_list_ids', {
    is: Joi.array().items(
      Joi.string()
        .only(NUMBER_OF_FIELD_ITEM_TYPE.itemA)
        .required(),
      Joi.any()
    ),
    then: Joi.any()
      .required()
      .disallow(null),
  }), // 作業場所A
  b_item_id: Joi.number().when('required_item_list_ids', {
    is: Joi.array().items(
      Joi.string()
        .only(NUMBER_OF_FIELD_ITEM_TYPE.itemB)
        .required(),
      Joi.any()
    ),
    then: Joi.required(),
  }), // 作業場所B
  c_item_id: Joi.number().when('required_item_list_ids', {
    is: Joi.array().items(
      Joi.string()
        .only(NUMBER_OF_FIELD_ITEM_TYPE.itemC)
        .required(),
      Joi.any()
    ),
    then: Joi.required(),
  }), // 作業場所C
  d_item_id: Joi.number().when('required_item_list_ids', {
    is: Joi.array().items(
      Joi.string()
        .only(NUMBER_OF_FIELD_ITEM_TYPE.itemD)
        .required(),
      Joi.any()
    ),
    then: Joi.required(),
  }), // 作業場所D
  contents: Joi.string()
    .required()
    .max(255), // 作業内容
  option1_must_flag: Joi.number(),
  option1: Joi.string()
    .allow('')
    .max(255)
    .when('option1_must_flag', {
      is: 1,
      then: Joi.required().disallow(''),
    }),
  option2_must_flag: Joi.number(),
  option2: Joi.string()
    .allow('')
    .max(255)
    .when('option2_must_flag', {
      is: 1,
      then: Joi.required().disallow(''),
    }),
  option3_must_flag: Joi.number(),
  option3: Joi.string()
    .allow('')
    .max(255)
    .when('option3_must_flag', {
      is: 1,
      then: Joi.required().disallow(''),
    }),
  // dayworker_type: Joi.string(), // 契約
  option4_must_flag: Joi.number(),
  option4: Joi.string()
    .max(31)
    .when('option4_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option5_must_flag: Joi.number(),
  option5: Joi.string()
    .max(31)
    .when('option5_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option6_must_flag: Joi.number(),
  option6: Joi.string()
    .max(31)
    .when('option6_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option7_must_flag: Joi.number(),
  option7: Joi.string()
    .max(31)
    .when('option7_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option8_must_flag: Joi.number(),
  option8: Joi.string()
    .max(31)
    .when('option8_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option9_must_flag: Joi.number(),
  option9: Joi.string()
    .max(31)
    .when('option9_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option10_must_flag: Joi.number(),
  option10: Joi.string()
    .max(31)
    .when('option10_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option11_must_flag: Joi.number(),
  option11: Joi.string()
    .max(31)
    .when('option11_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option12_must_flag: Joi.number(),
  option12: Joi.string()
    .max(31)
    .when('option12_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option13_must_flag: Joi.number(),
  option13: Joi.string()
    .max(31)
    .when('option13_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option14_must_flag: Joi.number(),
  option14: Joi.string()
    .max(31)
    .when('option14_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option15_must_flag: Joi.number(),
  option15: Joi.string()
    .max(31)
    .when('option15_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option16_must_flag: Joi.number(),
  option16: Joi.string()
    .max(31)
    .when('option16_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option17_must_flag: Joi.number(),
  option17: Joi.string()
    .max(31)
    .when('option17_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option18_must_flag: Joi.number(),
  option18: Joi.string()
    .max(31)
    .when('option18_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option19_must_flag: Joi.number(),
  option19: Joi.string()
    .max(31)
    .when('option19_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  option20_must_flag: Joi.number(),
  option20: Joi.string()
    .max(31)
    .when('option20_must_flag', {
      is: 1,
      then: Joi.string()
        .required()
        .disallow(''),
      otherwise: Joi.string().allow(''),
    }),
  memo: Joi.string()
    .max(31)
    .allow(null, ''), // 指示書備考欄
  hot_work_code: Joi.any().allow(null, ''), // 火気種別
  hot_work_start: Joi.string().allow('', null), // 火気開始
  hot_work_end: Joi.string().allow('', null), // 火気終了
  oxygen_lack_dangerous_work_upper: Joi.string()
    .max(62)
    .allow(''),
  oxygen_lack_dangerous_work_lower: Joi.string()
    .max(62)
    .allow(''),
  oxygen_lack_education_complete_upper: Joi.string()
    .max(62)
    .allow(''),
  oxygen_lack_education_complete_lower: Joi.string()
    .max(62)
    .allow(''),
  manager_user_id: Joi.number().allow(null, ''), // 元請担当者
  work_key_plan_image: Joi.any().allow(null, ''), // キープラン
  groups: Joi.string(), // 印刷グループ
  work_early_times: Joi.any(), // 早出
  work_over_times: Joi.any(), // 残業
  schedule_flag: Joi.string(), // 予定フラグ
  display_fifteen_minute_flg: Joi.bool().required(),
});

//clone WorkHour keys from workEditFormSchema
export const workHourBatchEditSchema = Joi.object().keys({
  dayworker_type: Joi.string(), // 契約
  woman: Joi.string().allow(null, ''), // 女性
  non_japanese: Joi.string().allow(null, ''), // 外国人
  work_dayworkers: Joi.array()
    .items(dayworkerFormSchema)
    .required(), // 人工
  work_early_times: Joi.any(), // 早出
  work_over_times: Joi.any(), // 残業
  display_fifteen_minute_flg: Joi.bool().required(),
});



// WEBPACK FOOTER //
// ./src/utilities/validationSchemas/workMultipleEdit.js